import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

/* ─── Contact FAB — V3 design (bombot-customers-v3_2026-07-22.html) ───────── */
const MessengerButton = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const popRef = useRef(null);
  const fabRef = useRef(null);

  // close popup when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (
        popRef.current && !popRef.current.contains(e.target) &&
        fabRef.current && !fabRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <>
      {/* CONTACT POPUP */}
      {open && (
        <div ref={popRef} style={styles.pop} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div style={styles.popHd}>
            <div style={styles.popTitle}>{t('messenger_btn.title')}</div>
            <div style={styles.popSub}>{t('messenger_btn.subtitle')}</div>
          </div>

          {/* Contact list */}
          <div style={styles.contactList}>
            {/* Messenger */}
            <a
              style={styles.item}
              href="https://www.facebook.com/messages/t/103634791744953"
              target="_blank"
              rel="noreferrer"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#EFF6FF" }}>
                <svg viewBox="0 0 16 16" style={{ width: 16, height: 16, strokeWidth: 1.8, fill: "none", stroke: "#1D4ED8" }}>
                  <path d="M8 1.5C4.4 1.5 1.5 4.2 1.5 7.6c0 1.9.9 3.6 2.4 4.7v2.2l2.2-1.2c.6.2 1.2.2 1.9.2 3.6 0 6.5-2.7 6.5-6.1S11.6 1.5 8 1.5z"/>
                  <path d="M4.5 9.5L7 7l1.8 1.5L11.5 6"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>Facebook Messenger</div>
                <div style={styles.desc}>{t('messenger_btn.fb_desc')}</div>
              </div>
            </a>

            {/* Telegram */}
            <a
              style={styles.item}
              href="https://t.me/+JhqGc8DW6Bs3MDk1"
              target="_blank"
              rel="noreferrer"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#DBEAFE" }}>
                <svg viewBox="0 0 16 16" style={{ width: 16, height: 16, fill: "#2563EB" }}>
                  <path d="M14.5 1.5l-13 5s-.9.3-.9.9c0 .5.5.7.5.7l3.4 1.1 1.3 4.3s.2.5.5.5c.2 0 .4-.2.4-.2l2-1.9 3.6 2.7s.4.2.8.2c.3 0 .6-.3.7-.5.1-.3 2.5-12.5 2.5-12.5s.2-.9-.4-1-.7 0-.7 0zm-1.9 2.3l-6.8 6.2-.3 2.3-1-3.4 8.1-5.1z"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>Telegram</div>
                <div style={styles.desc}>BOMBOT SUPPORT</div>
              </div>
            </a>

            {/* WhatsApp */}
            <a
              style={styles.item}
              href="https://wa.me/84977705134"
              target="_blank"
              rel="noreferrer"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#DCFCE7" }}>
                <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, fill: "#25D366" }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>WhatsApp</div>
                <div style={styles.desc}>0977705134</div>
              </div>
            </a>

            {/* Zalo */}
            <a
              style={styles.item}
              href="https://zalo.me/g/xhwsof136"
              target="_blank"
              rel="noreferrer"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#DBEAFE" }}>
                <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, fill: "#0068FF" }}>
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 13.5h-4v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-2c-.55 0-1-.45-1-1 0-.4.24-.76.61-.92L11.5 11c.4-.16.6-.58.48-.98-.12-.4-.52-.64-.93-.52l-4 1.5c-.4.15-.87-.02-1.02-.43-.15-.4.02-.87.43-1.02l4-1.5c1-.38 2.08-.02 2.7.9.62.92.5 2.13-.3 2.88l-2.36 2.17h4c.55 0 1 .45 1 1s-.45 1-1 1z"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>Zalo</div>
                <div style={styles.desc}>BOMBOT.VN - Hỗ trợ</div>
              </div>
            </a>

            {/* Hotline */}
            <a
              style={styles.item}
              href="tel:02871010134"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#F0FDF4" }}>
                <svg viewBox="0 0 16 16" style={{ width: 16, height: 16, strokeWidth: 1.8, fill: "none", stroke: "#16A34A" }}>
                  <path d="M3 2h3l1.5 3.5-2 1.5c.8 1.8 2.2 3.2 4 4l1.5-2L14.5 10.5V13.5c0 .6-.4 1-1 1C7 14.5 1.5 9 1.5 2.5c0-.3.2-.5.5-.5z"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>Hotline</div>
                <div style={styles.desc}>028 7101 0134</div>
              </div>
            </a>

            {/* Email */}
            <a
              style={styles.item}
              href="mailto:hotro@bombot.vn"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#FFFBEB" }}>
                <svg viewBox="0 0 16 16" style={{ width: 16, height: 16, strokeWidth: 1.8, fill: "none", stroke: "#92400E" }}>
                  <rect x="1.5" y="3" width="13" height="10" rx="1.5"/>
                  <path d="M1.5 4.5L8 9l6.5-4.5"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>Email</div>
                <div style={styles.desc}>hotro@bombot.vn</div>
              </div>
            </a>

            {/* Hotro site */}
            <a
              style={styles.item}
              href="https://hotro.bombot.vn"
              target="_blank"
              rel="noreferrer"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{ ...styles.ic, background: "#EFF6FF" }}>
                <svg viewBox="0 0 16 16" style={{ width: 16, height: 16, strokeWidth: 1.8, fill: "none", stroke: "#1D4ED8" }}>
                  <circle cx="8" cy="8" r="6"/><path d="M8 5v3l2 1.5"/>
                </svg>
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>{t('messenger_btn.support_title')}</div>
                <div style={styles.desc}>hotro.bombot.vn</div>
              </div>
            </a>
          </div>
        </div>
      )}

      {/* FAB BUTTON */}
      <button
        ref={fabRef}
        title={t('messenger_btn.fab_title')}
        onClick={() => setOpen((v) => !v)}
        style={styles.fab}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 10px 26px rgba(22,163,74,0.42)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "none";
          e.currentTarget.style.boxShadow = "0 6px 20px rgba(22,163,74,0.35)";
        }}
      >
        {open ? (
          /* X icon when open */
          <svg viewBox="0 0 24 24" style={{ width: 22, height: 22, stroke: "#fff", strokeWidth: 2, fill: "none" }}>
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        ) : (
          /* Chat icon */
          <svg viewBox="0 0 24 24" style={{ width: 22, height: 22, stroke: "#fff", strokeWidth: 1.8, fill: "none" }}>
            <path d="M21 11.5a8.5 8.5 0 01-8.5 8.5c-1.3 0-2.6-.3-3.7-.8L3 21l1.8-5.3A8.3 8.3 0 013.9 11.5 8.5 8.5 0 0112.5 3 8.5 8.5 0 0121 11.5z"/>
            <path d="M8.5 10.5h7M8.5 13.5h4.5"/>
          </svg>
        )}
      </button>
    </>
  );
};

/* ─── Inline styles (no MUI dependency) ──── */
const styles = {
  fab: {
    position: "fixed",
    right: 24,
    bottom: 72,
    zIndex: 89,
    width: 52,
    height: 52,
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    background: "#22C55E",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 6px 20px rgba(22,163,74,0.35)",
    transition: "transform 0.12s, box-shadow 0.12s",
    padding: 0,
  },
  pop: {
    position: "fixed",
    right: 24,
    bottom: 134,
    zIndex: 150,
    width: 264,
    background: "#ffffff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    boxShadow: "0 16px 40px rgba(0,0,0,0.16)",
    overflow: "hidden",
    animation: "popIn 0.15s ease",
  },
  popHd: {
    padding: "13px 16px",
    background: "linear-gradient(120deg, #14532D 0%, #16A34A 60%, #22C55E 100%)",
    color: "#fff",
  },
  popTitle: {
    fontSize: 13,
    fontWeight: 700,
    fontFamily: "'Be Vietnam Pro', sans-serif",
  },
  popSub: {
    fontSize: 11,
    opacity: 0.85,
    marginTop: 2,
    fontFamily: "'Be Vietnam Pro', sans-serif",
  },
  contactList: {
    padding: 6,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 11,
    padding: "9px 10px",
    borderRadius: 8,
    cursor: "pointer",
    textDecoration: "none",
    background: "transparent",
    transition: "background 0.12s",
  },
  ic: {
    width: 34,
    height: 34,
    borderRadius: 8,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  meta: {
    minWidth: 0,
  },
  name: {
    fontSize: 12.5,
    fontWeight: 600,
    color: "#111827",
    fontFamily: "'Be Vietnam Pro', sans-serif",
  },
  desc: {
    fontSize: 11,
    color: "#9CA3AF",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: "'Be Vietnam Pro', sans-serif",
  },
};

export default MessengerButton;
